import { gql } from '@apollo/client';

export const REQUEST_SUBSIDY_CERTIFICATE_PDF = gql`
  mutation RequestSubsidyCertificatePDF($input: RequestSubsidyCertificatePDFInput!) {
    requestSubsidyCertificatePDF(input: $input)
  }
`;
